import styled from 'styled-components'
import { withTheme } from '../../theme'

export const BlackLightText = withTheme(styled.span`
  font-family: Satoshi-Bold;
  color: ${_ => _.theme.backgroundColor};
  font-size: ${_ => _.fontSize || '1.25rem'};
  line-height: ${_ => _.lineHeight || '1.5625rem'};
  `)
